var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnacksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 81,
    viewBox: "0 0 88 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7538 31.6816H5.04818C4.57197 31.6816 4.19141 32.0622 4.19141 32.634L7.99961 77.8606C8.09459 79.1935 9.2376 80.2409 10.5706 80.2409H33.3266C34.6596 80.2409 35.802 79.1935 35.8976 77.8606L39.7058 32.634C39.6101 32.1578 39.2296 31.6816 38.7534 31.6816H38.7538Z",
    fill: "#FF5910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1503 55.8659H86.5682C87.33 55.8659 87.9012 55.1041 87.8062 54.3424C86.9494 49.4866 82.665 45.6777 77.5231 45.6777H54.1958C49.0546 45.6777 44.7694 49.3911 43.9127 54.3424C43.8177 55.1042 44.3889 55.8659 45.1507 55.8659H45.1503Z",
    fill: "#FF5910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5686 70.1484H45.1507C44.3889 70.1484 43.8177 70.9102 43.9127 71.672C44.7694 76.5277 49.0539 80.2409 54.1958 80.2409H77.5231C82.6643 80.2409 86.9494 76.5276 87.8062 71.672C87.9968 70.8146 87.4256 70.1484 86.5689 70.1484H86.5686Z",
    fill: "#FF5910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7619 59.4844H45.0583C44.3915 59.4844 43.8203 60.0556 43.8203 60.7224V65.2924C43.8203 65.9593 44.3915 66.5304 45.0583 66.5304H86.7619C87.4287 66.5304 87.9999 65.9593 87.9999 65.2924V60.7224C87.9999 60.0562 87.4287 59.4844 86.7619 59.4844Z",
    fill: "#FF5910"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0366 22.4457H23.2316V8.44924L31.42 3.11744C31.8006 2.83185 31.8962 2.35564 31.6106 1.97508L30.5632 0.356531C30.2777 -0.0240349 29.8015 -0.119674 29.4209 0.165916L20.3758 6.069C19.8995 6.44956 19.519 7.02141 19.519 7.59257V22.6363H2.57094C1.14301 22.6363 0 23.7787 0 25.2073V25.7785C0 27.2064 1.14236 28.3494 2.57094 28.3494H40.9421C42.37 28.3494 43.513 27.207 43.513 25.7785V25.2073C43.6073 23.5887 42.4643 22.4457 41.0364 22.4457L41.0366 22.4457Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnacksIcon);
export default __webpack_public_path__ + "static/media/snacksIcon.061b08ef90af650c9d7b0f8125e2677d.svg";
export { ForwardRef as ReactComponent };